import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./App.css";

import FullpageWrapper from "./main/main";
import { Routes, Route, useLocation } from "react-router-dom";
import TeamMemberInfo from "./pages/team/TeamMemberInfo/TeamMemberInfo";
import InnoProgram from "./pages/academic/InnoProgram/InnoProgram";
import Internship from "./pages/academic/Internship/Internship";
import RoboChallenge from "./pages/academic/robotChallange/RoboChallenge/RoboChallenge";
import QualifiedTm from "./pages/academic/robotChallange/QualifiedTm/QualifiedTm";
import QualifiedTm3 from "./pages/academic/robotChallange/QualifiedTm3/QualifiedTm3";
import LabletProgram from "./pages/academic/LabletProgram/LabletProgram";
import ReimagineHealth from "./pages/health/ReimagineHealth";
import ReimaginJourney from "./pages/reimaginJourney/ReimaginJourney/ReimaginJourney";
import Governance from "./pages/governance/Governance/Governance";
import DesktopNavbar from "./main/components/DesktopNavbar";
import MobileNav from "./main/components/MobileNav";
import Resources from "./pages/resources/Resources";
import React, { useEffect, useState } from "react";
import Events from "./pages/events/Events";
import Publication from "./pages/publication/Publication";
import Collaborators from "./pages/collaborators/Collaborators";
import Footer from "./pages/footer/Footer/Footer";
import TechMoonshots from "./pages/techmoonshots/publication/TechMoonshots";
import * as queries from "./utils/prismicQueries";
import client from "./utils/prismicHelpers";
import Advertisement from "./main/components/Advertisement";
import Podcast from "./pages/Podcast/Podcast";
import Notification from "./main/components/Notification";
import Event from "./pages/event/Event";
import Frontline from "./pages/frontline/Frontline";
import AboutSection from "./pages/about/AboutSection/AboutSection";
import Certification from "./pages/certification/Certification";
import Newsletter from "./main/components/Newsletter/Newsletter";
import { Toaster } from 'react-hot-toast';
import Rep from "./pages/rep/Rep";
function App() {
  const [open, setOpen] = useState(false);
  const [adInfo, setAdInfo] = useState(null);

  const location = useLocation();
  useEffect(() => {

    client
      .query({
        query: queries.advertisements,
      })
      .then((response) => {
        const advertisementsDoc = response.data.allAdvertisments.edges[0].node;
        const filteredBanner = advertisementsDoc?.slider?.filter(banner => banner.hide === false)
        setAdInfo(filteredBanner);

        setTimeout(() => {
          const endDate = new Date(advertisementsDoc?.date);
          const dateRemaining = Math.round((endDate.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));

          if (location.pathname !== "/event" && dateRemaining >= 0) {
            setOpen(true);
          }
          else {
            setOpen(false);
          }
        }, 5000);
      })
      .catch((error) => {
        console.error(error);
      });


  }, []);

  return (
    <>
      <Toaster />
      <Notification />
      <DesktopNavbar />
      <MobileNav />
      <Newsletter />
    
      <Routes>
        <Route path="/" element={<FullpageWrapper />} />
        <Route path="/test-about" element={<AboutSection />} />
        <Route path="/reimagine-health" element={<ReimaginJourney />} />
        <Route path="/innoProgramme" element={<InnoProgram />} />
        <Route path="/internship" element={<Internship />} />
        <Route path="/robotChallenge" element={<RoboChallenge />} />
        <Route path="/qualifiedtm" element={<QualifiedTm />} />
        <Route path="/qualifiedtm3" element={<QualifiedTm3 />} />
        <Route path="/labletprogram" element={<LabletProgram />} />
        <Route path="/governance" element={<Governance />} />
        <Route path="/events" element={<Events />} />
        <Route path="/event/:id" element={<Event />} />
        <Route path="/publication" element={<Publication />} />
        <Route path="/collaborators" element={<Collaborators />} />
        <Route path="/techmoonshots" element={<TechMoonshots />} />
        <Route path="/certification" element={<Certification />} />
        <Route
          path="/reimagine-health/2030_rural_india"
          element={<ReimagineHealth />}
        />
        <Route
          path="/reimagine-health/2030_frontline_health"
          element={<Frontline />}
        />
        <Route path="/team" element={<TeamMemberInfo />} />
        <Route path="/podcast" element={<Podcast />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/RFP" element={<Rep />} />

      </Routes>

      <Footer />

      <Advertisement adInfo={adInfo} show={open} setShow={setOpen} />
    </>

  );
}

export default App;
